import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getForYouFeed,
  getProfilePosts,
  postResetSaved,
  setPostsView,
} from "../features/posts/postSlice";
import PostItem from "./PostItem";
import styled from "styled-components";
import { toast } from "react-toastify";
import {
  logoutUserFaraSesiune,
  resetUserForLogout,
} from "../features/auth/authSlice";
import NoPosts from "./postComponents/NoPosts";
import Loader from "loaders/Loader";
import AddContent from "./userProfile/AddContent";
import useGetWindowSize from "hooks/useGetWindowSize";
import GoToChurch from "./userProfile/GoToChurch";
import { useTranslation } from "react-i18next";

function MyPostFeed(props) {
  const { t } = useTranslation("feed");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [url, setUrl] = useState("my-posts");
  const [urlLocation, setUrlLocation] = useState(window.location.href);
  const { user, admin, moderator } = useSelector((state) => state.auth);
  const { profileChurch } = useSelector((state) => state.profileChurch);
  const [isModerator, setIsModerator] = useState(false);
  const [width, height] = useGetWindowSize();

  const {
    posts,
    isPostLoading,
    isPostError,
    postsMessage,
    currentPage,
    filterValue,
    isPostSaved,
    userProfilePostsView,
  } = useSelector((state) => state.posts);

  const listInnerRef = useRef();

  useEffect(() => {
    if (isPostError) {
      toast.error(postsMessage);
      if (postsMessage === "Not logged in") {
        dispatch(logoutUserFaraSesiune());
        dispatch(resetUserForLogout());
        navigate("/login");
        window.location.reload();
      }
    }
  }, [isPostError, postsMessage, dispatch, navigate]);

  useEffect(() => {
    if (isPostSaved) {
      toast.success(t("saved"), {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      dispatch(postResetSaved());
    }
  }, [isPostSaved, dispatch]);

  useEffect(() => {
    if (!user.isOrganization && !user.isChurch) {
      if (urlLocation.includes("home") && !user.isOrganization) {
        setUrl("for-you");
        dispatch(setPostsView("for-you"));
      } else if (urlLocation.includes("my-posts")) {
        setUrl("my-posts");
        dispatch(setPostsView("my-posts"));
      } else if (urlLocation.includes("saved-posts")) {
        setUrl("saved-posts");
        dispatch(setPostsView("saved-posts"));
      }
    }
  }, [user, urlLocation, url, dispatch]);

  useEffect(() => {
    if (!url) {
      return;
    }

    if (userProfilePostsView === "for-you" || url === "for-you") {
      dispatch(getForYouFeed({ page: 0 }));
      return;
    }

    dispatch(
      getProfilePosts({
        churchName: null,
        currentPage: currentPage,
        filter: filterValue,
        posts: userProfilePostsView || url,
        sort: null,
      }),
    );
  }, [dispatch, userProfilePostsView, url]);

  return (
    <PostFeedContainer ref={listInnerRef} style={{ height: "80vh" }}>
      {userProfilePostsView !== "for-you" && <AddContent />}

      {posts && posts.length > 0 ? (
        <div className="posts">
          {posts.map((post, index) => (
            <PostItem
              key={post._id}
              index={index}
              postId={post._id}
              post={post}
              isAdmin={admin[profileChurch._id] || user.isOrganization}
              isModerator={moderator[profileChurch._id]}
            />
          ))}
        </div>
      ) : isPostLoading && !isPostError ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Loader />
        </div>
      ) : (
        <NoPosts mode={userProfilePostsView} />
      )}

      {width < 768 && posts && posts.length < 2 && <GoToChurch />}
    </PostFeedContainer>
  );
}

export default MyPostFeed;

const PostFeedContainer = styled.div`
  padding: 00px 10px 10px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  /* remove scroll bar width */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  z-index: 1;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  @media (max-width: 768px) {
    padding: 10px;
  }
`;
